module.exports = __webpack_public_path__ + "static/media/seves_desk.story.4443376a.jpg";